
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"image","d":"M16.5.5c.827 0 1.5.622 1.5 1.39v12.222c0 .766-.673 1.388-1.5 1.388h-15c-.827 0-1.5-.622-1.5-1.388V1.889C0 1.122.673.5 1.5.5h15zm-3.516 6.557l-3.42 3.491a.75.75 0 01-1.03.04L6.56 8.868 1.5 12.765V14h15v-3.668l-3.516-3.275zM16.5 2h-15v8.871l4.632-3.568a.75.75 0 01.856-.041l.095.07 1.904 1.661 3.437-3.508a.75.75 0 011.047-.024L16.5 8.282V2z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(0 1)"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#image"}})]),_c('use',{attrs:{"fill":"#8C99AD","xlink:href":"#image"}}),_c('g',{attrs:{"fill":"#2B2B2B","mask":"url(#b)"}},[_c('path',{attrs:{"d":"M-3-5h24v24H-3z"}})])])])
          )
        }
      }
    